import { render, staticRenderFns } from "./SpecialHall.vue?vue&type=template&id=1484c9f0"
import script from "./SpecialHall.vue?vue&type=script&lang=js"
export * from "./SpecialHall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports